import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./Login.css";
import Credin from "../../assets/Credin Logo (1).svg";
import Logo1 from "../../assets/C pannel Log in screen-01 1.svg";
import Logo2 from "../../assets/C pannel Log in screen-02.svg";
import Logo3 from "../../assets/C pannel Log in screen-03.svg";
import IconButton from "@mui/material/IconButton";
import OutlinedInput from "@mui/material/OutlinedInput";
import InputAdornment from "@mui/material/InputAdornment";
import FormControl from "@mui/material/FormControl";
import TextField from "@mui/material/TextField";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { Carousel } from "react-responsive-carousel";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import { url } from "../../App";
import { version } from "../../App";
import Cookies from 'js-cookie';

export default function StagingLogin() {
  const [open, setOpen] = React.useState(false);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [fyData, setFyData] = useState("");
  const navigate = useNavigate();

  const handleEmail = (e) => {
    setEmail(e.target.value);
  };
  const fetch = async () => {
    const { data } = await axios.get('https://api.ipify.org')
    setFyData(data);
  }

  useEffect(() => {
    fetch()
  }, [])
  const handlePassword = (e) => {
    setPassword(e.target.value);
  };

  const [showPassword, setShowPassword] = useState(false);

  const handleClickShowPassword = () => setShowPassword((show) => !show);

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // console.log("Submitted Form");
    // toast.info("Validating Credentials...",{
    //   autoClose : false,
    //   toastId : "custom"
    // })
    setOpen(true);
    axios
      .post(url + "/user/lmslogin", {
        email: email,
        password: password,
        ip: fyData,
        hostname: window.location.href,
        latitude: "22.30516956900325",
        longitude: "73.17319436857136",
      })
      .then((res) => {
        if (res.data.auth === true) {
          // console.log(res.data);
          // toast.dismiss("custom");
          setOpen(false);
          toast.success(res.data.message);
          Cookies.set('Token', res.data.token, { expires: 1 });
          Cookies.set('Email', email, { expires: 1 });
          setTimeout(() => {
            navigate("/home");
          }, 2000);
        } else if (res.data.password === false) {
          // toast.dismiss("custom");
          setOpen(false);
          toast.error(res.data.message);
        } else {
          // toast.dismiss("custom");
          setOpen(false);
          toast.error(res.data.message);
        }
      })
      .catch((err) => {
        console.log(err);
        // toast.dismiss("custom");
        setOpen(false);
        toast.error("Login failed : " + err.message);
      });
  };

  const date = new Date().getFullYear();

  return (
    <div className="main-login">
      <div className="container-login">
        <form onSubmit={handleSubmit}>
          <div className="input-login">
            <div className="credin-logo-login">
              <img src={Credin} alt="Credin Logo" />
            </div>
            <div className="input-item-login">
              <label className="label-login">Username or Email</label>
              <br />
              <TextField
                className="input-field-login"
                variant="outlined"
                required
                name="email"
                onChange={handleEmail}
                value={email}
                style={{ backgroundColor: "#F0F4F7", width: "30ch" }}
                size="small"
              />
            </div>
            <div className="input-item-login">
              <label className="label-login">Password</label>
              <FormControl
                sx={{ width: "30ch", display: "block" }}
                variant="outlined"
              >
                <OutlinedInput
                  type={showPassword ? "text" : "password"}
                  size="small"
                  required
                  value={password}
                  onChange={handlePassword}
                  name="password"
                  style={{ backgroundColor: "#F0F4F7", fontSize: "1.17rem" }}
                  endAdornment={
                    <InputAdornment position="end">
                      <IconButton
                        aria-label="toggle password visibility"
                        onClick={handleClickShowPassword}
                        onMouseDown={handleMouseDownPassword}
                        edge="end"
                      >
                        {showPassword ? <VisibilityOff /> : <Visibility />}
                      </IconButton>
                    </InputAdornment>
                  }
                />
              </FormControl>
            </div>
            <button type="submit" className="btn-submit-login">
              Login
            </button>
          </div>
        </form>
        <div className="svg-login">
          <div className="image-login">
            <div className="slider-container">
              <Carousel
                showThumbs={false}
                infiniteLoop
                autoPlay
                interval={3000}
                showArrows={false}
                showStatus={false}
              >
                <div>
                  <img
                    src={Logo1}
                    alt=""
                    style={{ width: "18rem", height: "18rem" }}
                  />
                </div>
                <div>
                  <img
                    src={Logo2}
                    alt=""
                    style={{ width: "18rem", height: "18rem" }}
                  />
                </div>
                <div>
                  <img
                    src={Logo3}
                    alt=""
                    style={{ width: "18rem", height: "18rem" }}
                  />
                </div>
              </Carousel>
            </div>
          </div>
          <div className="para-login">
            <div>
              <p>Loan Management System</p>
            </div>
            <div style={{ fontSize: ".9rem" }}>v{version}</div>
            <div style={{ fontSize: ".7rem", fontWeight: "400" }}>
              All rights reserved &copy; Upkram Technologies Pvt. Ltd. @{date}
            </div>
          </div>
        </div>
      </div>
      <ToastContainer />
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={open}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
    </div>
  );
}
